import React from 'react';
import { Box } from '@mui/material';
import AdminDashboard from './AdminDashboard';
// Import CSS if needed
// import '../chatbot-v2.css';

const ChatbotV2Dashboard: React.FC = () => {
  return (
    <Box 
      sx={{ 
        width: '100%', 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }} 
      className="chatbot-v2-dashboard-container"
    >
      <AdminDashboard />
    </Box>
  );
};

export default ChatbotV2Dashboard; 
